module.exports = __webpack_public_path__ + "static/media/potion.24ff54d9.mp3";